// ================= THE 5Fs — shared behavior =================

document.addEventListener('DOMContentLoaded', function () {

  /* ---------- Horizontal scroller arrows ---------- */
  document.querySelectorAll("[data-scroll-target]").forEach(button => {

    button.addEventListener("click", function () {

        const container = document.querySelector(this.dataset.scrollTarget);

        const card = container.querySelector(".exp-item");

        const gap = 24;

        const direction = this.dataset.dir === "prev" ? -1 : 1;

        container.scrollBy({
            left: direction * (card.offsetWidth + gap),
            behavior: "smooth"
        });

    });

});



  document.querySelectorAll(".featured-products [data-scroll-target]").forEach(button => {

    button.addEventListener("click", function () {

        const container = document.querySelector(this.dataset.scrollTarget);

        if (!container) return;

        const card = container.querySelector(".product-card");

        if (!card) return;

        const gap = 20;

        const direction = this.dataset.dir === "prev" ? -1 : 1;

        container.scrollBy({
            left: direction * (card.offsetWidth + gap),
            behavior: "smooth"
        });

    });

});




  document.querySelectorAll(".signature-oil-slider [data-scroll-target]").forEach(button=>{

button.addEventListener("click",function(){

const container=document.querySelector(this.dataset.scrollTarget);

const card=container.querySelector(".slider-item");

const gap=24;

const direction=this.dataset.dir==="prev"?-1:1;

container.scrollBy({

left:direction*(card.offsetWidth+gap),

behavior:"smooth"

});

});

});




  document.querySelectorAll(".pocket-squares-slider [data-scroll-target]").forEach(button => {

    button.addEventListener("click", function(){

        const container=document.querySelector(this.dataset.scrollTarget);

        if(!container) return;

        const card=container.querySelector(".slider-item");

        if(!card) return;

        const gap=20;

        const direction=this.dataset.dir==="prev" ? -1 : 1;

        container.scrollBy({

            left:direction*(card.offsetWidth+gap),

            behavior:"smooth"

        });

    });

});

  document.querySelectorAll(".silk-scarves-slider [data-scroll-target]").forEach(button => {

    button.addEventListener("click", function(){

        const container = document.querySelector(this.dataset.scrollTarget);

        if(!container) return;

        const card = container.querySelector(".slider-item");

        if(!card) return;

        const gap = 20;

        const direction = this.dataset.dir === "prev" ? -1 : 1;

        container.scrollBy({
            left: direction * (card.offsetWidth + gap),
            behavior: "smooth"
        });

    });

});

  /* ---------- Wishlist heart toggle ---------- */
  document.querySelectorAll('.wishlist-heart').forEach(function (h) {
    h.addEventListener('click', function (e) {
      e.preventDefault();
      h.classList.toggle('active');
      h.innerHTML = h.classList.contains('active')
        ? '<i class="bi bi-heart-fill"></i>'
        : '<i class="bi bi-heart"></i>';
    });
  });

  /* ---------- Category tabs (Shop All) ---------- */
  document.querySelectorAll('.cat-tab').forEach(function (tab) {
    tab.addEventListener('click', function () {
      document.querySelectorAll('.cat-tab').forEach(t => t.classList.remove('active'));
      tab.classList.add('active');
      var targetId = tab.getAttribute('data-target');
      var section = document.getElementById(targetId);
      if (section) section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  /* ---------- Instant search filter (Shop All) ---------- */
  var searchInput = document.getElementById('shopSearch');
  if (searchInput) {
    searchInput.addEventListener('input', function () {
      var q = searchInput.value.trim().toLowerCase();
      document.querySelectorAll('.product-card[data-name]').forEach(function (card) {
        var name = card.getAttribute('data-name').toLowerCase();
        var wrap = card.closest('[data-item]');
        if (wrap) wrap.style.display = (q === '' || name.includes(q)) ? '' : 'none';
      });
    });
  }

  /* ---------- Cart Drawer ---------- */
  var cart = [];
  var drawer = document.getElementById('cartDrawer');
  var backdrop = document.getElementById('cartDrawerBackdrop');
  var cartCountEls = document.querySelectorAll('.cart-count');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('show');
    backdrop.classList.add('show');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('show');
    backdrop.classList.remove('show');
    document.body.style.overflow = '';
  }
  document.querySelectorAll('[data-close-drawer]').forEach(el => el.addEventListener('click', closeDrawer));
  if (backdrop) backdrop.addEventListener('click', closeDrawer);
  document.querySelectorAll('[data-open-drawer]').forEach(el => el.addEventListener('click', function(e){ e.preventDefault(); openDrawer(); }));

  function renderCart(justAddedName) {
    if (!drawer) return;
    var lineWrap = drawer.querySelector('.cart-lines');
    var confirmBanner = drawer.querySelector('.confirm-banner');
    var justAdded = drawer.querySelector('.just-added');
    var subtotalEl = drawer.querySelector('.cart-subtotal');
    var totalEl = drawer.querySelector('.cart-total');
    var countEl = drawer.querySelector('.cart-count-label');

    lineWrap.innerHTML = '';
    var subtotal = 0;
    var count = 0;
    cart.forEach(function (item, idx) {
      subtotal += item.price * item.qty;
      count += item.qty;
      var row = document.createElement('div');
      row.className = 'd-flex align-items-start gap-3 mb-3 cart-line-item';
      row.innerHTML =
        '<img src="' + item.img + '" alt="' + item.name + '">' +
        '<div class="flex-grow-1">' +
          '<div class="d-flex justify-content-between"><span class="fw-semibold">' + item.name + '</span>' +
          '<button class="btn btn-sm p-0 text-danger" data-remove="' + idx + '"><i class="bi bi-trash"></i></button></div>' +
          '<div class="text-secondary small">' + item.variant + '</div>' +
          '<div class="d-flex justify-content-between small mt-1"><span>Qty: ' + item.qty + '</span><span class="fw-semibold">$' + (item.price * item.qty).toFixed(2) + '</span></div>' +
        '</div>';
      lineWrap.appendChild(row);
    });

    lineWrap.querySelectorAll('[data-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        cart.splice(parseInt(btn.getAttribute('data-remove'), 10), 1);
        renderCart();
      });
    });

    if (subtotalEl) subtotalEl.textContent = '$' + subtotal.toFixed(2);
    if (totalEl) totalEl.textContent = '$' + subtotal.toFixed(2) + ' USD';
    if (countEl) countEl.textContent = count;
    cartCountEls.forEach(el => el.textContent = count);

    if (justAddedName && justAdded) {
      justAdded.style.display = 'flex';
    } else if (justAdded) {
      justAdded.style.display = 'none';
    }
  }

  window.addToCart = function (product) {
    var existing = cart.find(i => i.name === product.name && i.variant === product.variant);
    if (existing) existing.qty += product.qty;
    else cart.push(product);
    renderCart(product.name);
    openDrawer();
  };

  document.querySelectorAll('[data-add-to-cart]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      window.addToCart({
        name: btn.getAttribute('data-name'),
        variant: btn.getAttribute('data-variant') || '',
        price: parseFloat(btn.getAttribute('data-price')),
        img: btn.getAttribute('data-img'),
        qty: 1
      });
    });
  });

  renderCart();
});
